package com.leaguetennis.shared.domain

import com.leaguetennis.shared.model.*

object StatsCalculator {
    fun computePlayerStats(playerId: String, leagueId: String, ranking: Int, matches: List<Match>): PlayerStats {
        var matchesWon = 0
        var matchesLost = 0
        var setsWon = 0
        var setsLost = 0
        var gamesWon = 0
        var gamesLost = 0
        var tieBreaksWon = 0
        var tieBreaksLost = 0

        matches.filter { it.leagueId == leagueId }.forEach { match ->
            val score = match.score ?: return@forEach
            val winnerSide = match.winnerSide ?: return@forEach

            val isPlayerSide1 = when (match) {
                is SinglesMatch -> match.player1Id == playerId
                is DoublesMatch -> match.team1Player1Id == playerId || match.team1Player2Id == playerId
            }
            val isPlayerSide2 = when (match) {
                is SinglesMatch -> match.player2Id == playerId
                is DoublesMatch -> match.team2Player1Id == playerId || match.team2Player2Id == playerId
            }

            if (!isPlayerSide1 && !isPlayerSide2) return@forEach

            val playerSide = if (isPlayerSide1) MatchWinner.SIDE1 else MatchWinner.SIDE2

            // Match won/lost
            if (winnerSide == MatchWinner.TIE) {
                // For a tie, it's neither a win nor a loss for either player.
                // We might want to track ties separately in PlayerStats in the future, 
                // but for now we just don't increment matchesWon or matchesLost.
            } else if (winnerSide == playerSide) {
                matchesWon++
            } else {
                matchesLost++
            }

            // Sets and Games
            score.sets.forEach { set ->
                val (playerGames, opponentGames) = if (playerSide == MatchWinner.SIDE1) {
                    set.side1Games to set.side2Games
                } else {
                    set.side2Games to set.side1Games
                }

                gamesWon += playerGames
                gamesLost += opponentGames

                val isCompleteSet = playerGames >= 6 || opponentGames >= 6
                if (isCompleteSet) {
                    if (playerGames > opponentGames) {
                        setsWon++
                    } else if (opponentGames > playerGames) {
                        setsLost++
                    }
                }

                val (playerTieBreak, opponentTieBreak) = if (playerSide == MatchWinner.SIDE1) {
                    set.side1TieBreak to set.side2TieBreak
                } else {
                    set.side2TieBreak to set.side1TieBreak
                }

                if (playerTieBreak != null && opponentTieBreak != null) {
                    if (playerTieBreak > opponentTieBreak) {
                        tieBreaksWon++
                    } else if (opponentTieBreak > playerTieBreak) {
                        tieBreaksLost++
                    }
                }
            }
        }

        return PlayerStats(
            playerId = playerId,
            leagueId = leagueId,
            ranking = ranking,
            matchesWon = matchesWon,
            matchesLost = matchesLost,
            setsWon = setsWon,
            setsLost = setsLost,
            gamesWon = gamesWon,
            gamesLost = gamesLost,
            tieBreaksWon = tieBreaksWon,
            tieBreaksLost = tieBreaksLost
        )
    }
}
